import '../../styles/lifeatcentrico.scss';
import ScrollToAnchor from '../../ScrollToAnchor';
import InnerHeader from "../InnerHeader"
import GreatPlaceToWork from './GreatPlaceToWork';
import EmployerOfChoice from './EmployerOfChoice';
import JoinUs from './JoinUs';
import VibrantWorkplace from './VibrantWorkplace';
import CommunityResponsiveness from './CommunityResponsiveness';
import { useTranslation } from "react-i18next";

export default function LifeAtCentrico(){
    const { t } = useTranslation();

    return(
        <>
            <ScrollToAnchor/>
            <InnerHeader breadcrumb={t(`lifeatcentrico.breadcrumb`)} title={t(`lifeatcentrico.title`)} />
            <GreatPlaceToWork />
            <EmployerOfChoice/>
            <JoinUs />
            <VibrantWorkplace/>
            <CommunityResponsiveness/>
        </>
    )
}